export default "__VITE_ASSET__smM6rD_v__"